import { render, staticRenderFns } from "./OrganizationModal.vue?vue&type=template&id=23884390&scoped=true&"
import script from "./OrganizationModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23884390",
  null
  
)

export default component.exports